import axios, {AxiosError, AxiosResponse} from 'axios';
import {PaymentObject} from './types';
import {ErrorObject} from 'types';
import {CourseObject} from '../course';

/**
 * This function gets the payments.
 * @return {Promise<PaymentObject[] | ErrorObject>}
 */
export async function getPayments() {
  return axios({
    method: 'GET',
    url: `${process.env.REACT_APP_API_BASE_URL}/students/payments`,
  }).then((response: AxiosResponse<PaymentObject[]>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}

/**
 * This function gets the student courses.
 * @return {Promise<CourseObject[] | ErrorObject>}
 */
export async function getCourses() {
  return axios({
    method: 'GET',
    url: `${process.env.REACT_APP_API_BASE_URL}/students/courses`,
  }).then((response: AxiosResponse<CourseObject[]>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}
